module.exports = __webpack_public_path__ + "static/dinner_room_night-4309dcc9f1690b4a77f5cd737932b5ac.jpg";